import { Component, OnInit } from '@angular/core';
import { UserService } from 'src/app/services/user.service';
import { Router } from '@angular/router';
import { MatSnackBar } from '@angular/material';
import { MetaService } from 'src/app/services/meta.service';

import * as moment from 'moment';

@Component({
  selector: 'app-users-table',
  templateUrl: './users-table.component.html',
  styleUrls: ['./users-table.component.css'],
  host: { '(document:keypress)': 'handleKeyboardEvent($event)' }
})
export class UsersTableComponent implements OnInit {

  users = [];
  queryMismatch = false;
  serviceAgents = [];
  isLoading = false;

  public search = {
    firstName: '',
    lastName: '',
    email: '',
    dateOfBirth: '',
    verified: '',
    mobile: ''
  }

  constructor(private usersService: UserService, private metaService: MetaService, private router: Router, private snackbar: MatSnackBar) { }

  ngOnInit() {
    this.isLoading = true;
    const data = new FormData()
    this.usersService.getUsersAdAdmin(data).subscribe(result => {
      this.queryMismatch = false;
      this.isLoading = false;
      this.users = result.data;
    }, error => {
      this.queryMismatch = true;
      this.isLoading = false;
      this.snackbar.open(error.error.data, 'Dismiss', {
        duration: 3000
      });
    });

    this.metaService.getMetaData().subscribe(result => {
      if (result.success) {
        this.serviceAgents = result.data.serviceAgents;
      }
    }, error => {
      this.snackbar.open(error.error.data, 'Dismiss', {
        duration: 3000
      });
    })
  }

  onViewOrder(mobile: string) {
    this.router.navigate(['/admin/users/orders/'], { queryParams: { mobile: mobile } })
  }

  addOrder(mobile: string) {
    this.router.navigate(['/admin/users/orders/create/'], { queryParams: { mobile: mobile } })
  }

  onSearch() {
    this.isLoading = true;
    const data = new FormData();

    if (this.search.firstName == '') {
      data.delete('firstName');
    } else {
      data.append('firstName', this.search.firstName);
    }

    if (this.search.lastName == '') {
      data.delete('lastName');
    } else {
      data.append('lastName', this.search.lastName);
    }

    if (this.search.email == '') {
      data.delete('email');
    } else {
      data.append('email', this.search.email);
    }

    if (this.search.mobile == '') {
      data.delete('mobile');
    } else {
      data.append('mobile', this.search.mobile);
    }

    if (this.search.dateOfBirth == '') {
      data.delete('dateOfBirth');
    } else {
      const date = new Date(this.search.dateOfBirth)
      data.append('dateOfBirth', moment(date).format('DD-MM-YYYY'));
    }

    if (this.search.verified == '' || this.search.verified == 'none') {
      data.delete('verified');
    } else {
      data.append('verified', this.search.verified);
    }

    this.usersService.getUsersAdAdmin(data).subscribe(result => {
      this.queryMismatch = false;
      this.isLoading = false;
      this.users = result.data;
    }, error => {
      this.queryMismatch = true;
      this.isLoading = false;
      this.snackbar.open(error.error.data, 'Dismiss', {
        duration: 3000
      });
    });
  }

  handleKeyboardEvent(event: KeyboardEvent) {
    if (event.key == 'Enter' && event.shiftKey == false) {
      this.onSearch();
    } else if (event.key == 'Enter' && event.shiftKey == true) {
      this.onClear();
    }
  }

  onClear() {
    this.search = {
      firstName: '',
      lastName: '',
      email: '',
      dateOfBirth: '',
      verified: '',
      mobile: ''
    }

    this.isLoading = true;
    const data = new FormData()
    this.usersService.getUsersAdAdmin(data).subscribe(result => {
      this.queryMismatch = false;
      this.isLoading = false;
      this.users = result.data;
    }, error => {
      this.queryMismatch = true;
      this.isLoading = false;
      this.snackbar.open(error.error.data, 'Dismiss', {
        duration: 3000
      });
    });

    this.metaService.getMetaData().subscribe(result => {
      if (result.success) {
        this.serviceAgents = result.data.serviceAgents;
      }
    }, error => {
      this.snackbar.open(error.error.data, 'Dismiss', {
        duration: 3000
      });
    })
  }
}
